function TransactionReportsCtrl(toaster, $scope, $state, $stateParams, $rootScope, TransactionReportsService) {
  'ngInject';

  const vm = this;
  const orgId = $stateParams.orgId;

  vm.runs = [];
  vm.mapping = {};
  vm.accounts = [];
  vm.loading = true;
  vm.uploading = false;
  vm.selectedFile = null;
  vm.marketplace = 'amazon.com';
  vm.accountsLoading = false;
  vm.accountsError = null;

  vm.marketplaces = [
    { value: 'amazon.com', label: 'Amazon US' },
    { value: 'amazon.ca', label: 'Amazon CA' },
    { value: 'amazon.com.mx', label: 'Amazon MX' }
  ];

  // Load runs
  vm.load = function () {
    vm.loading = true;
    TransactionReportsService.getRuns(orgId, { marketplace: vm.marketplace }).then(function (response) {
      vm.runs = response.data.runs || [];
      vm.loading = false;
    }).catch(function (error) {
      toaster.pop('error', 'Error', 'Failed to load transaction reports');
      vm.loading = false;
    });
  };

  // Load mapping/settings
  vm.loadMapping = function () {
    TransactionReportsService.getMapping(orgId, vm.marketplace).then(function (response) {
      vm.mapping = response.data.settings || {};
    });
  };

  // Load Xero accounts
  vm.loadAccounts = function () {
    vm.accountsLoading = true;
    TransactionReportsService.getAccounts(orgId).then(function (response) {
      vm.accounts = response.data.accounts || [];
      vm.accountsLoading = false;
    }).catch(function(error) {
      console.error('Failed to load Xero accounts:', error);
      vm.accountsLoading = false;
      vm.accountsError = 'Failed to load Xero accounts. Is Xero connected?';
    });
  };

  // File selected
  vm.onFileSelect = function (files) {
    if (files && files.length > 0) {
      vm.selectedFile = files[0];
    }
  };

  // Upload file
  vm.upload = function () {
    if (!vm.selectedFile) {
      toaster.pop('warning', 'No File', 'Please select a file to upload');
      return;
    }

    vm.uploading = true;
    TransactionReportsService.upload(orgId, vm.selectedFile, vm.marketplace, function(response) {
      vm.uploading = false;
      if (response.status === 200) {
        toaster.pop('success', 'Uploaded', response.data.message || 'Transaction report uploaded and parsed successfully');
        vm.selectedFile = null;
        vm.load();
      } else {
        toaster.pop('error', 'Upload Failed', response.data?.error || 'Failed to upload file');
      }
    });
  };

  // Save mapping
  vm.saveMapping = function () {
    vm.mapping.marketplace = vm.marketplace;
    TransactionReportsService.saveMapping(orgId, vm.mapping).then(function (response) {
      toaster.pop('success', 'Saved', 'Account mapping saved');
      vm.mapping = response.data.mapping || vm.mapping;
      vm.load(); // Refresh runs to update statuses
    }).catch(function (error) {
      toaster.pop('error', 'Error', 'Failed to save mapping');
    });
  };

  // Post to Xero
  vm.postToXero = function (run) {
    if (!confirm('Post ' + run.period_display + ' to Xero?')) return;

    TransactionReportsService.postToXero(orgId, run.id).then(function (response) {
      toaster.pop('success', 'Posted', 'Journal entry created in Xero');
      vm.load();
    }).catch(function (error) {
      toaster.pop('error', 'Error', error.data?.error || 'Failed to post to Xero');
    });
  };

  // Delete run
  vm.deleteRun = function (run) {
    if (!confirm('Delete ' + run.period_display + '? This cannot be undone.')) return;

    TransactionReportsService.deleteRun(orgId, run.id).then(function () {
      toaster.pop('success', 'Deleted', 'Report deleted');
      vm.load();
    }).catch(function (error) {
      toaster.pop('error', 'Error', 'Failed to delete report');
    });
  };

  // Retry run
  vm.retryRun = function (run) {
    TransactionReportsService.retryRun(orgId, run.id).then(function () {
      toaster.pop('success', 'Refreshed', 'Report status updated');
      vm.load();
    }).catch(function (error) {
      toaster.pop('error', 'Error', 'Failed to refresh report');
    });
  };

  // Format currency
  vm.formatCurrency = function (amount) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount || 0);
  };

  // Status badge class
  vm.statusClass = function (status) {
    switch (status) {
      case 'done': return 'label-success';
      case 'ready': return 'label-primary';
      case 'mapping': return 'label-warning';
      case 'error': return 'label-danger';
      default: return 'label-default';
    }
  };

  // Initialize
  vm.load();
  vm.loadMapping();
  vm.loadAccounts();
}

TransactionReportsCtrl.$inject = ['toaster', '$scope', '$state', '$stateParams', '$rootScope', 'TransactionReportsService'];

export default {
  name: 'TransactionReportsCtrl',
  fn: TransactionReportsCtrl
};
